// extracted by mini-css-extract-plugin
module.exports = {"send":"SendMessage_send__fcjFN","scroll":"SendMessage_scroll__1gJiQ","sendWithFiles":"SendMessage_sendWithFiles__1QD4O"};